export const LOCALE_KEY = 'MyPlaces3';
